import React from "react";
import {useStyles} from "./styles/ComponentsStyle";
import {inject, observer} from "mobx-react";
import Box from "@material-ui/core/Box";
import {injectIntl} from "react-intl";

function LoadingBox(props) {
    const {isLoading, loadingText} = props.commonStore;
    const classes = useStyles();
    const {intl} = props;

    const defaultLoadingText = intl.formatMessage({id: "msg_info_loading_data"});

    return (
        isLoading ?
            <Box className={classes.loadingBox}>
                <Box className={classes.dotLoader}>
                    <Box className={classes.dot} />
                    <Box className={classes.dot} />
                    <Box className={classes.dot} />
                </Box>
                <Box className={classes.loadingBoxTitle}>{loadingText || defaultLoadingText}</Box>
            </Box> :
            <React.Fragment/>

    );
}
export default inject('commonStore')(injectIntl(observer(LoadingBox)));
